import bilditContact from './bilditContact.cjs';

export const { INTERNAL_NOTIFY_TO, BILDIT_FROM } = bilditContact;
